import { render, staticRenderFns } from "./BlogSingle.vue?vue&type=template&id=906a2196&scoped=true&"
import script from "./BlogSingle.vue?vue&type=script&lang=js&"
export * from "./BlogSingle.vue?vue&type=script&lang=js&"
import style0 from "./BlogSingle.vue?vue&type=style&index=0&id=906a2196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906a2196",
  null
  
)

export default component.exports